import { Directive, Input, TemplateRef } from "@angular/core";


@Directive({
  selector: "ng-template[grayCell]",
})
export class GrayCellTemplateDirective {
  @Input("grayCell") key!: string;
  constructor(public readonly template: TemplateRef<any>) {}
}
